<template>
  <validation-provider v-slot="{ errors }"
                       :name="name"
                       :class="{ 'text-field_has-errors': !!errors.length }"
                       :rules="validate"
                       tag="div"
                       class="text-field">

    <div class="text-field-body">
      <v-text-field v-model="intervalVal"
                    :label="label ? `${label} ${ isRequired ? '*' : '' }` : undefined"
                    :disabled="disabled"
                    :error-messages="errors"
                    :mask="mask"
                    :type="type"
                    :min="min"
                    @blur="emitBlur"
                    @input="emitVal">
        <template v-if="help"
                  v-slot:append>
          <i v-tooltip.html="help"
             class="mdi mdi-help-circle-outline pointer text-field-help"></i>
        </template>
      </v-text-field>

      <button v-if="action"
              class="btn btn-sm text-field-action"
              @click="emitAction()">
        <i v-if="action.icon"
           :class="`mdi ${action.icon} pointer text-field-action-icon`"></i>
        <p class="text-muted text-field-action-label">{{ action.label }}</p>
      </button>
    </div>

    <p v-if="text || errors.length"
       class="text-field-text"
       :class="{ 'text-field-text_has-errors': !!errors.length }">{{ errors[0] || text }}</p>

  </validation-provider>
</template>
 
<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },

  data() {
    return {
      intervalVal: this.value,
    };
  },

  computed: {
    isRequired() {
      return this.validate && this.validate.includes("required");
    },
  },

  watch: {
    value: function (val) {
      this.intervalVal = val;
    },
  },

  props: {
    validate: {
      Type: String,
    },
    name: {
      Type: String,
    },
    label: {
      Type: String,
    },
    value: {
      Type: String,
    },
    action: {
      Type: Object,
    },
    disabled: {
      Type: Boolean,
    },
    help: {
      type: [String, Object],
    },
    text: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
    min: {
      type: Number,
    },
    mask: {
      type: String,
    },
  },

  mixins: [],

  methods: {
    emitVal(newVal) {
      const valToEmit = this.type === "number" ? Number(newVal) : newVal;

      this.$emit("input", valToEmit);
    },
    emitAction() {
      this.$emit("action", this.value);
    },
    emitBlur(data) {
      this.$emit("blur", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-field {
  margin-bottom: 10px;

  .text-field-body {
    display: flex;

    .text-field-help {
      color: #707070;
    }

    .v-input {
      ::v-deep .v-text-field__details {
        display: none;
      }

      ::v-deep input {
        /* Chrome, Safari, Edge, Opera */
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        &[type="number"] {
          -moz-appearance: textfield;
        }
      }
    }

    .text-field-action {
      display: flex;
      align-items: center;
      box-shadow: none;
      padding: 0;
      margin-left: 10px;

      .text-field-action-icon {
        margin-right: 5px;
      }

      .text-field-action-label {
        margin: 0;
        color: #262626;
      }
    }
  }

  .text-field-text {
    color: #707070;
    font-size: 14px;
    text-align: left;
    margin-bottom: 0;

    &.text-field-text_has-errors {
      color: #ff4141;
    }
  }
}
</style>
